import React, { useCallback } from "react";
import { SearchInput } from "@toddle-edu/ds-web";
import { useI18n } from "Hooks";
import { useParticipantsModal } from "../../context/ParticipantsModalContext";
import classes from "./ParticipantSearch.scss";

const PLACEHOLDER_MAP = {
  GRADES: "calendar:search_grades",
  COURSES: "course:search_courses",
  STUDENTS: "common:search_students",
  FAMILY: "calendar:search_family_members",
  STAFF: "calendar:search_staff_members",
};

/**
 * Search bar that filters the participant list.
 * Dynamic placeholder changes based on active tab.
 * Reads/writes searchText from ParticipantsModalContext.
 */
const ParticipantSearch = () => {
  const { t } = useI18n(["calendar", "course"]);
  const { searchText, setSearchText, activeTab } = useParticipantsModal();

  const handleSearchChange = useCallback(
    value => {
      setSearchText(value);
    },
    [setSearchText]
  );

  return (
    <div className={classes.searchContainer}>
      <SearchInput
        dsVersion="2.0"
        value={searchText}
        onChange={handleSearchChange}
        placeholder={t(PLACEHOLDER_MAP[activeTab])}
        size="medium"
        focusSearchBySlash={true}
        testId="participants-search-input"
      />
    </div>
  );
};

export default ParticipantSearch;
